module.exports = __webpack_public_path__ + "img/escaledu.50119680.png";